import {
  FETCH_DROPDOWNLIST_REQUEST,
  FETCH_DROPDOWNLIST_SUCCESS,
  FETCH_DROPDOWNLIST_FAILURE,
} from "./dropdownDataTypes";
import api from "../../utils/Api";

export const fetchDropdownListRequest = () => {
  return {
    type: FETCH_DROPDOWNLIST_REQUEST,
  };
};

export const fetchDropdownListSuccess = (dropdownList) => {
  return {
    type: FETCH_DROPDOWNLIST_SUCCESS,
    payload: dropdownList,
  };
};

export const fetchDropdownListFailure = (error) => {
  return {
    type: FETCH_DROPDOWNLIST_FAILURE,
    payload: error,
  };
};

export const fetchDropdownList = () => {
  return async (dispatch) => {
    dispatch(fetchDropdownListRequest);
    try {
      const response = await api.get("dropdown/list/fetch");
      const dropdownList = response.data.data;
      dispatch(fetchDropdownListSuccess(dropdownList));
    } catch (error) {
      console.log("Fetch in dropdown list redux error - ", error.response);
      const errorMsg = error.message;
      dispatch(fetchDropdownListFailure(errorMsg));
    }
  };
};
